<div class="main">
    <div class="container-fluid">
        <!-- Header Section -->
        <div class="meetings-header d-flex flex-wrap justify-content-between align-items-start m-2 m-md-4">
            <div class="meetings-title-container mb-3 mb-md-0">
                <button class="btn back-btn p-0 mb-2 d-flex align-items-center" (click)="goBack()"
                    aria-label="Go back to Minutes of Meeting">
                    <i class="fas fa-arrow-left me-2"></i>
                    Go back to Minutes of Meeting
                </button>
                <div class="d-flex flex-wrap align-items-center gap-2 gap-md-3 mb-2">
                    <h3 class="mb-0 meeting-title">Minutes of Meeting Details</h3>
                    <app-status-badge *ngIf="minutesDetails" [text]="minutesDetails?.quickInfo?.currentStage || 'Draft'"
                        [color]="getStatusColor(minutesDetails?.quickInfo?.currentStage || 'Draft')" [size]="'medium'">
                    </app-status-badge>
                </div>
                <span class="breadcrumb-section mt-2">
                    <a [routerLink]="['/' + AppConstants.ROUTES.HOME]"
                        class="meetings-header-title breadcrumb-link">Dashboard <i class="lni lni-chevron-right"
                            aria-hidden="true"></i></a>
                    <a [routerLink]="['/' + AppConstants.ROUTES.MINUTES_OF_MEETING]"
                        class="meetings-header-title breadcrumb-link">Minutes of Meeting <i
                            class="lni lni-chevron-right" aria-hidden="true"></i></a>
                    <span>{{ minutesDetails?.basicInfo?.meetingId || meetingId }}</span>
                </span>
            </div>
            <div class="d-flex align-items-center gap-3 action-buttons-header">
                <button class="btn action-btn-white" (click)="exportWord()" aria-label="Export Word">
                    <i class="fas fa-download me-2"></i>
                    Export Minutes as Word
                </button>
                <button class="btn action-btn-white" (click)="resendApprovalEmails()" aria-label="Resend Approval Emails" *ngIf="showResendEmailButton">
                    <i class="fas fa-envelope me-2"></i>
                    Resend Email
                </button>
                <button class="btn action-btn-pink" (click)="publishMOM()" aria-label="Publish MOM"
                    *ngIf="showPublishButton">
                    Publish
                </button>
                <button class="btn action-btn-pink" (click)="republishMOM()" aria-label="Re-publish MOM"
                    *ngIf="showRepublishButton">
                    <i class="fas fa-redo me-2"></i>
                    Re-publish
                </button>
                <!-- Approval Buttons (shown when token is present) -->
                <div class="d-flex align-items-center gap-2" *ngIf="showApprovalButtons">
                    <button class="btn action-btn-green" (click)="approveMOM()" aria-label="Approve MOM">
                        <i class="fas fa-check me-2"></i>
                        Approve
                    </button>
                    <button class="btn action-btn-orange" (click)="requestChangeMOM()" aria-label="Request Changes">
                        <i class="fas fa-edit me-2"></i>
                        Change Request
                    </button>
                </div>
            </div>
        </div>

        <!-- Main Content - Two Column Layout -->
        <div class="row m-2 m-md-4">
            <!-- Left Column -->
            <div>
                <!-- Basic Information Card -->
                <fieldset class="content-fieldset mb-4" *ngIf="minutesDetails">
                    <legend class="section-legend">Basic Information</legend>
                    <div class="basic-info-content">
                        <div class="info-grid">
                            <div class="info-column">
                                <div class="info-item mb-3">
                                    <div class="info-label">Subject:</div>
                                    <div class="info-value">{{ minutesDetails?.basicInfo?.subject }}</div>
                                </div>
                                <div class="info-item mb-3">
                                    <div class="info-label">Created Date:</div>
                                    <div class="info-value">{{ minutesDetails?.basicInfo?.createdDate }}</div>
                                </div>
                                <div class="info-item">
                                    <div class="info-label">Location:</div>
                                    <div class="info-value">{{ minutesDetails?.basicInfo?.location }}</div>
                                </div>
                            </div>
                            <div class="info-column">
                                <div class="info-item mb-3">
                                    <div class="info-label">Meeting ID:</div>
                                    <div class="info-value meeting-id-value">{{ minutesDetails?.basicInfo?.meetingId }}
                                    </div>
                                </div>
                                <div class="info-item">
                                    <div class="info-label">Meeting Date & Time:</div>
                                    <div class="info-value">{{ minutesDetails.basicInfo?.meetingDate }} {{
                                        minutesDetails.basicInfo?.meetingTime }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>

                <!-- Member Approval Status -->
                <fieldset class="content-fieldset mb-4" *ngIf="minutesDetails">
                    <legend class="section-legend">Member Approval Status</legend>
                    <div class="approval-status-content">
                        <div class="table-responsive">
                            <table class="approval-status-table">
                                <thead>
                                    <tr>
                                        <th>Member Name</th>
                                        <th>Role</th>
                                        <th>Action</th>
                                        <th>Comment</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let member of getAttendedMembers(); trackBy: trackByMember">
                                        <td>{{ member.userName || member.userNameAr }}</td>
                                        <td>{{ member.role }}</td>
                                        <td>
                                            <span class="approval-badge"
                                                [ngClass]="getApprovalBadgeClass(getMomApprovalStatusName(member))">
                                                {{ getMomApprovalStatusName(member) || 'Pending' }}
                                            </span>
                                        </td>
                                        <td>
                                            <span
                                                *ngIf="isChangeRequestedStatus(getMomApprovalStatusName(member)) && member.momApprovalReason"
                                                class="comment-text">
                                                {{ member.momApprovalReason }}
                                            </span>
                                            <span
                                                *ngIf="!member.momApprovalReason || !isChangeRequestedStatus(getMomApprovalStatusName(member))"
                                                class="comment-text-empty">
                                                -
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </fieldset>

                <!-- Meeting Minutes Section -->
                <fieldset class="content-fieldset mb-4" *ngIf="minutesDetails">
                    <legend class="section-legend">Meeting Minutes</legend>

                    <!-- Attendance Table Container -->
                    <div class="attendance-container mb-4"
                        *ngIf="minutesDetails?.meetingMinutes?.attendanceTable && minutesDetails!.meetingMinutes!.attendanceTable.length > 0">
                        <h5 class="attendance-title mb-3">Attendance :</h5>
                        <div class="table-responsive">
                            <table class="attendance-table-view">
                                <thead>
                                    <tr>
                                        <th>الرقم</th>
                                        <th>اسم العضو</th>
                                        <th>الصفة</th>
                                        <th>حضور الإجتماع</th>
                                        <th>Role</th>
                                        <th>Member Name</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        *ngFor="let member of minutesDetails!.meetingMinutes!.attendanceTable; trackBy: trackByAttendanceMember">
                                        <td>{{ member.number }}</td>
                                        <td>{{ member.memberNameArabic }}</td>
                                        <td>{{ member.roleArabic }}</td>
                                        <td>
                                            <svg *ngIf="member.attendance" width="20" height="20" viewBox="0 0 20 20"
                                                fill="none" xmlns="http://www.w3.org/2000/svg" class="check-icon">
                                                <path
                                                    d="M9.99935 18.3332C14.6017 18.3332 18.3327 14.6022 18.3327 9.99984C18.3327 5.39746 14.6017 1.6665 9.99935 1.6665C5.39698 1.6665 1.66602 5.39746 1.66602 9.99984C1.66602 14.6022 5.39698 18.3332 9.99935 18.3332Z"
                                                    stroke="#00A63E" stroke-width="1.66667" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                                <path d="M7.5 10.0002L9.16667 11.6668L12.5 8.3335" stroke="#00A63E"
                                                    stroke-width="1.66667" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                            <svg *ngIf="!member.attendance" width="20" height="20" viewBox="0 0 20 20"
                                                fill="none" xmlns="http://www.w3.org/2000/svg" class="x-icon">
                                                <circle cx="10" cy="10" r="9" fill="#E63956" stroke="#E63956" />
                                                <path d="M6 6L14 14M14 6L6 14" stroke="white" stroke-width="2"
                                                    stroke-linecap="round" />
                                            </svg>
                                        </td>
                                        <td>{{ member.roleEnglish }}</td>
                                        <td>{{ member.memberNameEnglish }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <!-- Agenda Items with Decisions -->
                    <div class="agenda-decisions-container mb-4"
                        *ngIf="minutesDetails?.meetingMinutes?.items && minutesDetails!.meetingMinutes!.items.length > 0">
                        <h5 class="decisions-title mb-3">Decisions :</h5>
                        <div class="agenda-item-decision"
                            *ngFor="let item of minutesDetails!.meetingMinutes!.items; let i = index">
                            <div class="item-header-row mb-3">
                                <h5 class="item-header mb-0">Item #{{ item.itemNumber }} - {{ item.subject || item.company }}</h5>
                                <button
                                    *ngIf="showTCDecisionEditButtons && editingTCDecisionAgendaId !== item.agendaId"
                                    type="button"
                                    class="btn edit-decision-btn"
                                    (click)="startEditTCDecision(item)"
                                    aria-label="Edit TC Decision">
                                    <i class="fas fa-edit me-2"></i>
                                    Edit TC Decision
                                </button>
                            </div>
                            <div class="item-content-wrapper" *ngIf="editingTCDecisionAgendaId !== item.agendaId">
                                <div class="item-content-english">
                                    <p class="decision-label">Tender Committee Decision:</p>
                                    <div class="decision-text" [innerHTML]="getTrustedDecisionHtml(item.decisionEnglish, 'No TC Decision in English...')"></div>
                                </div>
                                <div class="item-separator"></div>
                                <div class="item-content-arabic">
                                    <p class="decision-label">قرار لجنة المناقصات:</p>
                                    <div class="decision-text" [innerHTML]="getTrustedDecisionHtml(item.decisionArabic, 'No TC Decision in Arabic...')"></div>
                                </div>
                            </div>
                            <div class="item-content-wrapper decision-edit-wrapper" *ngIf="editingTCDecisionAgendaId === item.agendaId">
                                <div class="item-content-english">
                                    <p class="decision-label">Tender Committee Decision:</p>
                                    <div class="rich-text-editor">
                                        <div class="editor-toolbar" (mousedown)="preserveEditorSelection($event, 'english', tcDecisionEnMomEditor)">
                                            <button type="button" class="toolbar-btn" (click)="executeEditorCommand(tcDecisionEnMomEditor, 'english', 'bold')" aria-label="Bold">
                                                <i class="fas fa-bold"></i>
                                            </button>
                                            <button type="button" class="toolbar-btn" (click)="executeEditorCommand(tcDecisionEnMomEditor, 'english', 'italic')" aria-label="Italic">
                                                <i class="fas fa-italic"></i>
                                            </button>
                                            <button type="button" class="toolbar-btn" (click)="executeEditorCommand(tcDecisionEnMomEditor, 'english', 'underline')" aria-label="Underline">
                                                <i class="fas fa-underline"></i>
                                            </button>
                                            <button type="button" class="toolbar-btn" (click)="executeEditorCommand(tcDecisionEnMomEditor, 'english', 'insertOrderedList')" aria-label="Numbered List">
                                                <i class="fas fa-list-ol"></i>
                                            </button>
                                            <button type="button" class="toolbar-btn" (click)="executeEditorCommand(tcDecisionEnMomEditor, 'english', 'insertUnorderedList')" aria-label="Bullet List">
                                                <i class="fas fa-list-ul"></i>
                                            </button>
                                            <label class="toolbar-btn toolbar-color-btn" aria-label="Text Color" title="Text Color">
                                                <i class="fas fa-font"></i>
                                                <span class="color-underline"></span>
                                                <input type="color" value="#532E60" (input)="executeEditorCommand(tcDecisionEnMomEditor, 'english', 'foreColor', $any($event.target).value)">
                                            </label>
                                            <button type="button" class="toolbar-btn toolbar-highlight-btn" (click)="executeEditorCommand(tcDecisionEnMomEditor, 'english', 'hiliteColor', '#FFF3B0')" aria-label="Highlight" title="Highlight">
                                                <span class="highlight-icon">A</span>
                                                <span class="highlight-preview"></span>
                                            </button>
                                            <button type="button" class="toolbar-btn" (click)="executeEditorCommand(tcDecisionEnMomEditor, 'english', 'removeFormat')" aria-label="Clear Formatting" title="Clear Formatting">
                                                <span class="clear-format-icon">Tx</span>
                                            </button>
                                        </div>
                                        <div
                                            #tcDecisionEnMomEditor
                                            class="editor-surface"
                                            contenteditable="true"
                                            data-tc-decision-editor="english"
                                            data-placeholder="Enter TC Decision in English"
                                            [class.is-empty]="isTCDecisionDraftEmpty('english')"
                                            (input)="onTCDecisionDraftInput('english', tcDecisionEnMomEditor)"
                                            (keyup)="saveEditorSelection('english', tcDecisionEnMomEditor)"
                                            (mouseup)="saveEditorSelection('english', tcDecisionEnMomEditor)"
                                            (focus)="saveEditorSelection('english', tcDecisionEnMomEditor)"
                                            (paste)="onTCDecisionEditorPaste($event, 'english', tcDecisionEnMomEditor)"
                                            (blur)="onTCDecisionEditorBlur('english')">
                                        </div>
                                    </div>
                                    <div class="mt-2">
                                        <button
                                            type="button"
                                            class="btn btn-sm translate-btn"
                                            (click)="onTranslateToArabicMom(tcDecisionArMomEditor)"
                                            [disabled]="!hasTCDecisionDraftText('english') || isTranslating">
                                            <span *ngIf="!isTranslating">Translate to Arabic</span>
                                            <span *ngIf="isTranslating">Translating...</span>
                                        </button>
                                    </div>
                                </div>
                                <div class="item-separator"></div>
                                <div class="item-content-arabic">
                                    <p class="decision-label">قرار لجنة المناقصات:</p>
                                    <div class="rich-text-editor arabic-editor">
                                        <div class="editor-toolbar" (mousedown)="preserveEditorSelection($event, 'arabic', tcDecisionArMomEditor)">
                                            <button type="button" class="toolbar-btn" (click)="executeEditorCommand(tcDecisionArMomEditor, 'arabic', 'bold')" aria-label="Bold">
                                                <i class="fas fa-bold"></i>
                                            </button>
                                            <button type="button" class="toolbar-btn" (click)="executeEditorCommand(tcDecisionArMomEditor, 'arabic', 'italic')" aria-label="Italic">
                                                <i class="fas fa-italic"></i>
                                            </button>
                                            <button type="button" class="toolbar-btn" (click)="executeEditorCommand(tcDecisionArMomEditor, 'arabic', 'underline')" aria-label="Underline">
                                                <i class="fas fa-underline"></i>
                                            </button>
                                            <button type="button" class="toolbar-btn" (click)="executeEditorCommand(tcDecisionArMomEditor, 'arabic', 'insertOrderedList')" aria-label="Numbered List">
                                                <i class="fas fa-list-ol"></i>
                                            </button>
                                            <button type="button" class="toolbar-btn" (click)="executeEditorCommand(tcDecisionArMomEditor, 'arabic', 'insertUnorderedList')" aria-label="Bullet List">
                                                <i class="fas fa-list-ul"></i>
                                            </button>
                                            <label class="toolbar-btn toolbar-color-btn" aria-label="Text Color" title="Text Color">
                                                <i class="fas fa-font"></i>
                                                <span class="color-underline"></span>
                                                <input type="color" value="#532E60" (input)="executeEditorCommand(tcDecisionArMomEditor, 'arabic', 'foreColor', $any($event.target).value)">
                                            </label>
                                            <button type="button" class="toolbar-btn toolbar-highlight-btn" (click)="executeEditorCommand(tcDecisionArMomEditor, 'arabic', 'hiliteColor', '#FFF3B0')" aria-label="Highlight" title="Highlight">
                                                <span class="highlight-icon">A</span>
                                                <span class="highlight-preview"></span>
                                            </button>
                                            <button type="button" class="toolbar-btn" (click)="executeEditorCommand(tcDecisionArMomEditor, 'arabic', 'removeFormat')" aria-label="Clear Formatting" title="Clear Formatting">
                                                <span class="clear-format-icon">Tx</span>
                                            </button>
                                        </div>
                                        <div
                                            #tcDecisionArMomEditor
                                            class="editor-surface"
                                            contenteditable="true"
                                            data-tc-decision-editor="arabic"
                                            data-placeholder="Enter TC Decision in Arabic"
                                            [class.is-empty]="isTCDecisionDraftEmpty('arabic')"
                                            (input)="onTCDecisionDraftInput('arabic', tcDecisionArMomEditor)"
                                            (keyup)="saveEditorSelection('arabic', tcDecisionArMomEditor)"
                                            (mouseup)="saveEditorSelection('arabic', tcDecisionArMomEditor)"
                                            (focus)="saveEditorSelection('arabic', tcDecisionArMomEditor)"
                                            (paste)="onTCDecisionEditorPaste($event, 'arabic', tcDecisionArMomEditor)"
                                            (blur)="onTCDecisionEditorBlur('arabic')">
                                        </div>
                                    </div>
                                </div>
                                <div class="decision-edit-actions">
                                    <button
                                        type="button"
                                        class="btn save-decision-btn"
                                        (click)="saveTCDecision(item, tcDecisionEnMomEditor, tcDecisionArMomEditor)">
                                        Save
                                    </button>
                                    <button
                                        type="button"
                                        class="btn cancel-decision-btn"
                                        (click)="cancelEditTCDecision()">
                                        Cancel
                                    </button>
                                </div>
                            </div>
                            <div class="voting-status-table" *ngIf="item.totalVotes && item.totalVotes > 0">
                                <table class="voting-table">
                                    <thead>
                                        <tr>
                                            <th>Voting Status</th>
                                            <th>حالة التصويت</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div class="vote-row">
                                                    <span class="vote-count accepted" *ngIf="item.acceptedVotes > 0">
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                                            xmlns="http://www.w3.org/2000/svg" class="vote-icon">
                                                            <circle cx="8" cy="8" r="7" fill="#00A63E"
                                                                stroke="#00A63E" />
                                                            <path d="M5 8L7 10L11 6" stroke="white" stroke-width="1.5"
                                                                stroke-linecap="round" stroke-linejoin="round" />
                                                        </svg>
                                                        {{ item.acceptedVotes }} Accepted
                                                    </span>
                                                    <span class="vote-count rejected" *ngIf="item.rejectedVotes > 0">
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                                            xmlns="http://www.w3.org/2000/svg" class="vote-icon">
                                                            <circle cx="8" cy="8" r="7" fill="#E63956"
                                                                stroke="#E63956" />
                                                            <path d="M5 5L11 11M11 5L5 11" stroke="white"
                                                                stroke-width="1.5" stroke-linecap="round" />
                                                        </svg>
                                                        {{ item.rejectedVotes }} Rejected
                                                    </span>
                                                    <span class="vote-count deferred"
                                                        *ngIf="item.deferredVotes && item.deferredVotes > 0">
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                                            xmlns="http://www.w3.org/2000/svg" class="vote-icon">
                                                            <circle cx="8" cy="8" r="7" fill="#E46A11"
                                                                stroke="#E46A11" />
                                                            <path d="M8 4V8L10 10" stroke="white" stroke-width="1.5"
                                                                stroke-linecap="round" stroke-linejoin="round" />
                                                        </svg>
                                                        {{ item.deferredVotes }} Deferred
                                                    </span>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="vote-row">
                                                    <span class="vote-count accepted" *ngIf="item.acceptedVotes > 0">
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                                            xmlns="http://www.w3.org/2000/svg" class="vote-icon">
                                                            <circle cx="8" cy="8" r="7" fill="#00A63E"
                                                                stroke="#00A63E" />
                                                            <path d="M5 8L7 10L11 6" stroke="white" stroke-width="1.5"
                                                                stroke-linecap="round" stroke-linejoin="round" />
                                                        </svg>
                                                        {{ item.acceptedVotes }} قبول
                                                    </span>
                                                    <span class="vote-count rejected" *ngIf="item.rejectedVotes > 0">
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                                            xmlns="http://www.w3.org/2000/svg" class="vote-icon">
                                                            <circle cx="8" cy="8" r="7" fill="#E63956"
                                                                stroke="#E63956" />
                                                            <path d="M5 5L11 11M11 5L5 11" stroke="white"
                                                                stroke-width="1.5" stroke-linecap="round" />
                                                        </svg>
                                                        {{ item.rejectedVotes }} رفض
                                                    </span>
                                                    <span class="vote-count deferred"
                                                        *ngIf="item.deferredVotes && item.deferredVotes > 0">
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                                            xmlns="http://www.w3.org/2000/svg" class="vote-icon">
                                                            <circle cx="8" cy="8" r="7" fill="#E46A11"
                                                                stroke="#E46A11" />
                                                            <path d="M8 4V8L10 10" stroke="white" stroke-width="1.5"
                                                                stroke-linecap="round" stroke-linejoin="round" />
                                                        </svg>
                                                        {{ item.deferredVotes }} تأجيل
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>

        </div>
    </div>
</div>
